import { render, staticRenderFns } from "./studentTransaction.vue?vue&type=template&id=6ef2fa08"
import script from "./studentTransaction.vue?vue&type=script&lang=js"
export * from "./studentTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports